module.exports = __webpack_public_path__ + "static/media/junit.65a4385b.png";